import { render, staticRenderFns } from "./atom-container-dumb-minimal.vue?vue&type=template&id=28373ffc&"
import script from "./atom-container-dumb-minimal.vue?vue&type=script&lang=js&"
export * from "./atom-container-dumb-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports